import React from 'react';
import PropTypes from 'prop-types';
import Link from './Link';
import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';

const StyledLink = styled(Link)`
  color: ${p => p.theme.colors.white};
  background-color: ${p => p.theme.colors.darkBg};
  display: block;
  height: 315px;
  overflow: hidden;
  position: relative;
  text-decoration: none;

  &:hover {
    color: ${p => p.theme.colors.white};
    text-decoration: underline;
  }
`;

const BgImage = styled.div`
  background-image: ${p => (p.image ? `url(${p.image})` : 'none')};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  transition: all 0.5s;
  width: 100%;
  text-decoration: inherit;
`;

const ReadMore = styled.div`
  align-items: center;
  color: ${p => p.theme.colors.white};
  display: flex;
  font-size: 0.75rem;
  justify-content: center;
  opacity: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  text-transform: uppercase;
  transition: opacity 1s;
  z-index: 99;
`;

const Content = styled.div`
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0) 30%,
    rgba(0, 0, 0, 1) 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 25px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  transition: opacity 0.5s;
  text-decoration: inherit;
`;

const Title = styled.h3`
  font-size: 1.5625rem;
  font-weight: 700;
  margin: 0 0 5px 0;
  line-height: 1.24;
  letter-spacing: 0.3px;
`;

const Subtitle = styled.p`
  font-size: 1.125rem;
  font-weight: 500;
  margin: 0;
  line-height: 1.22;
  letter-spacing: 0.2px;
  text-decoration: inherit;
`;

export default function ImageShortcut({
  url,
  image,
  title,
  subtitle,
  className
}) {
  return (
    <StyledLink to={url} className={className}>
      <BgImage image={image}>
        <ReadMore>Les mer »</ReadMore>

        <Content>
          <Subtitle>{title}</Subtitle>
        </Content>
      </BgImage>
    </StyledLink>
  );
}

ImageShortcut.propTypes = {
  url: PropTypes.string.isRequired,
  image: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  className: PropTypes.string.isRequired
};
